import { createActions } from 'redux-actions';

export const {
  //GET ALL ORDERS
  getAllOrders,
  getAllOrdersSuccess,
  getAllOrdersError,
  //GET FILTER ORDERS
  getFilterOrders,
  getFilterOrdersSuccess,
  getFilterOrdersError,
  watchOrder,
  watchOrderSuccess,
  watchOrderFailure,
  unwatchOrder,
  unwatchOrderSuccess,
  unwatchOrderFailure,
} = createActions(
  'GET_ALL_ORDERS',
  'GET_ALL_ORDERS_SUCCESS',
  'GET_ALL_ORDERS_ERROR',
  'GET_FILTER_ORDERS',
  'GET_FILTER_ORDERS_SUCCESS',
  'GET_FILTER_ORDERS_ERROR',
  'WATCH_ORDER',
  'WATCH_ORDER_SUCCESS',
  'WATCH_ORDER_FAILURE',
  'UNWATCH_ORDER',
  'UNWATCH_ORDER_SUCCESS',
  'UNWATCH_ORDER_FAILURE'
);
